import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import {
  CurrentUserQuery,
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { graphql } from "../../../generated/app-service-gql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { CURRENT_USER_QUERY_KEY } from "../users/useCurrentUser";

const updateCompanyMutation = graphql(`
  mutation updateCompany($input: UpdateCompanyRequest!) {
    updateCompany(company: $input) {
      guid
      name
    }
  }
`);

export function useUpdateCompany(
  options?: UseMutationOptions<
    UpdateCompanyMutation,
    unknown,
    UpdateCompanyMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  return useGraphQlMutation(updateCompanyMutation, {
    ...options,
    onSuccess: async (data, variables, context) => {
      queryClient.setQueryData<CurrentUserQuery>(CURRENT_USER_QUERY_KEY, (prev) => {
        if (!prev) return prev;
        return {
          currentUser: {
            ...prev.currentUser,
            company: {
              ...prev.currentUser.company,
              name: data.updateCompany.name,
            },
          },
        };
      });
      options?.onSuccess?.(data, variables, context);
    },
  });
}
